import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '../crud/CrudActionType';

const CampaignsPage = async () => import('../../pages/CampaignsPage.vue');
const CampaignFormPage = async () => import('../../pages/CampaignFormPage.vue');
const CampaignsMassEditModal = async () => import('./campaigns-mass-edit-modal/CampaignsMassEditModal.vue');

export default function getCampaignsRoutes(): RouteRecordRaw[] {
  return [
    {
      alias: '/campaigns',
      children: [
        {
          component: CampaignsMassEditModal,
          name: 'edit-many-campaigns',
          path: String.raw`edit/mass/:ids(\d+)+`,
          props: (route) => ({
            campaignIds: route.params.ids,
          }),
        },
      ],
      component: CampaignsPage,
      meta: {
        title: 'Campaigns',
        useIn: ['navigation-tabs'],
      },
      name: 'campaigns',
      path: '/',
    },
    {
      component: CampaignFormPage,
      meta: {
        title: 'Create campaign',
      },
      name: 'create-campaign',
      path: '/campaigns/create',
      props: {
        action: {
          type: CrudActionType.CREATE,
        },
      },
    },
    {
      component: CampaignFormPage,
      meta: {
        title: 'Edit campaign',
      },
      name: 'edit-campaign',
      path: '/campaigns/edit/:id',
      props: (route) => ({
        action: {
          id: route.params.id,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      component: CampaignFormPage,
      meta: {
        title: 'Clone campaign',
      },
      name: 'clone-campaign',
      path: '/campaigns/clone/:id',
      props: (route) => ({
        action: {
          id: route.params.id,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
